import React from 'react'
import './RightImgContent.css'

const RightImgContent = () => {
    return (
        <div className="right-img-content">
            <div className="right-img-content-left">
                <div className="right-img-content-text">
                    <h2 className="right-img-content-text-h2">
                        We use chargeable weights
                    </h2>
                    <p className="right-img-content-text-p">
                        We 940 air cargo as Freight forwarders we do not use gross weight or volume weight of the cargo but the 
                        chargeable weight when calculating freight cost?
                    </p>
                </div>
                <div className="right-img-content-card">
                    <p className="right-img-content-card-quote">
                        <q>
                            The pillar of any company that deals with logistics is the ability to deliver on time with minimal risk of loss
                        </q>
                    </p>
                </div>
            </div>
            <div className="right-img-content-right">
                
            </div>
        </div>
    )
}

export default RightImgContent
